import Vue from 'vue'
import Vuex from 'vuex'
import { router } from '@/router';
import { apolloClient } from '@/apollo'
import gql from "graphql-tag";

import moment from 'moment'
import axios from 'axios'

import { PublicClientApplication } from '@azure/msal-browser';

Vue.use(Vuex)

function parseJwt(token) {
  let jsonPayload = "{\"iat\":0,\"exp\":0}"
  if (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }
  return JSON.parse(jsonPayload);
};

export const store = new Vuex.Store({
  state: {
    tokenid: 'tp_orders_token',
    sidebarShow: 'responsive',
    sidebarMinimize: true,
    asideShow: false,
    darkMode: true,
    balance: "0.00",
    invoicing: false,
    selection: [],
    palette: [
      {
        backgroundColor: "rgba(32, 168, 216, 0.1)",
        borderColor: "#20a8d8",
        pointHoverBackgroundColor: "#20a8d8",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(248, 108, 107, 0.1)",
        borderColor: "#f86c6b",
        pointHoverBackgroundColor: "#f86c6b",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(77, 189, 116, 0.1)",
        borderColor: "#4dbd74",
        pointHoverBackgroundColor: "#4dbd74",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(66,62,200, 0.1)",
        borderColor: "#423ec8",
        pointHoverBackgroundColor: "#423ec8",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(107,60,202, 0.1)",
        borderColor: "#6b3cca",
        pointHoverBackgroundColor: "#6b3cca",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(159,58,204, 0.1)",
        borderColor: "#9f3acc",
        pointHoverBackgroundColor: "#9f3acc",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(207,55,115, 0.1)",
        borderColor: "#cf3773",
        pointHoverBackgroundColor: "#cf3773",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(203,59,69, 0.1)",
        borderColor: "#cb3b45",
        pointHoverBackgroundColor: "#cb3b45",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(207,83,55, 0.1)",
        borderColor: "#cf5337",
        pointHoverBackgroundColor: "#cf5337",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(201,156,61, 0.1)",
        borderColor: "#c99c3d",
        pointHoverBackgroundColor: "#c99c3d",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(173,205,57, 0.1)",
        borderColor: "#adcd39",
        pointHoverBackgroundColor: "#adcd39",
        borderWidth: 2
      },

      {
        backgroundColor: "rgba(27,128,217, 0.1)",
        borderColor: "#1b80d9",
        pointHoverBackgroundColor: "#1b80d9",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(9,38,235, 0.1)",
        borderColor: "#0926eb",
        pointHoverBackgroundColor: "#0926eb",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(69,9,235, 0.1)",
        borderColor: "#4509eb",
        pointHoverBackgroundColor: "#4509eb",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(127,5,239, 0.1)",
        borderColor: "#7f05ef",
        pointHoverBackgroundColor: "#7f05ef",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(242,2,239, 0.1)",
        borderColor: "#f202ef",
        pointHoverBackgroundColor: "#f202ef",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(230,14,95, 0.1)",
        borderColor: "#e60e5f",
        pointHoverBackgroundColor: "#e60e5f",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(227,31,17, 0.1)",
        borderColor: "#e31f11",
        pointHoverBackgroundColor: "#e31f11",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(233,104,11, 0.1)",
        borderColor: "#e9680b",
        pointHoverBackgroundColor: "#e9680b",
        borderWidth: 2
      },
      {
        backgroundColor: "rgba(233,193,11, 0.1)",
        borderColor: "#e9c10b",
        pointHoverBackgroundColor: "#e9c10b",
        borderWidth: 2
      }
    ],
    showClipboard: false,
    clipboard: null,
    user: null,
    busy: false,
    token: null,
    error: null,
    window: {
      width: 0,
      height: 0,
    },
    msalConfig: {
      auth: {
        clientId: process.env.VUE_APP_MSAL_CLIENTID,
        authority: process.env.VUE_APP_MSAL_AUTHORITY,
        redirectUri: process.env.VUE_APP_MSAL_REDIRECTURI
      },
      cache: {
        cacheLocation: 'localStorage',
      },
    },
  },
  mutations: {
    toggleSidebarDesktop(state) {
      const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
      const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
      state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
      if (variable == "error") {
        value.message = value.message.split("GraphQL error: Error: ").join("")
        state["busy"] = false
      }
      state[variable] = value
    },
    put(state, [variable, value]) {
      console.log(variable, value)
      state[variable].push(value)
    },
    async toggle(state, variable) {
      state[variable] = !state[variable]
      if (variable == "darkMode") {
        try {
          let result = await apolloClient.mutate({
            mutation: gql`
                mutation updateUser($id:String!, $theme:String) {
                  updateUser(id: $id, theme: $theme ) {
                    id
                    theme                                   
                  }
                }
            `,
            variables: {
              id: state.user.id,
              theme: state[variable] ? 'dark' : 'light'
            }
          })

        } catch (error) {
          // commit('set', ['error', error])
        }
      }
    },
    setUser: (state, payload) => {
      state.user = payload;
    },
    setLoading: (state, payload) => {
      state.loading = payload;
    },
    clearError: state => (state.error = null),
    setAccessToken(state, token) {
      state.accessToken = token;
    }
  },
  actions: {
    clearerror: async ({ commit }, payload) => {
      commit("clearError")
    },
    currentUser: async ({ commit, dispatch }) => {

      let jwtPayload = null

      let url = null
      try {
        url = new URL(window.location)
      } catch (error) {
        console.log(error)
      }

      if (url.searchParams.has("token")) {
        jwtPayload = parseJwt(url.searchParams.get("token"))
      } else {
        jwtPayload = parseJwt(localStorage.getItem(store.state.tokenid))
      }
      if (jwtPayload.exp < Date.now() / 1000) {
        commit("setUser", null)
        localStorage.setItem(store.state.tokenid, "")
        router.push('/signin')
      }
      commit('set', ['busy', true])

      let variables = {
        id: jwtPayload.id
      }

      try {
        let users = await apolloClient.query({
          query: gql`
            query setup_users($id: String) {
                setup_users (id: $id) {
                    id
                    name
                    email
                    initials
                    title
                    firstname
                    lastname
                    department
                    avatarb64
                    theme
                    slac
                    yourref
                    company
                    companylogob64
                    dateformat
                    timeformat
                    perpage
                    beats
                    idle
                    forcelogout
                    created_at
                    updated_at
                    permissions
                  }
                }
            `,
          variables
        })

        commit('set', ['busy', false])
        if (users.data.setup_users) {

          commit('set', ['user', users.data.setup_users[0]])

          if (users.data.setup_users[0].theme.toLowerCase() == "dark") {
            commit('set', ['darkMode', true])
            document.body.className = 'sc5 dark'
          } else {
            commit('set', ['darkMode', false])
            document.body.className = 'sc5'
          }

          // dispatch("notifications")

        }
      } catch (error) {
        commit('set', ['error', error])
      }
    },
    signinMS: async ({ commit }, payload) => {

      let query = await apolloClient.query({
        query: gql`
          query setup_systemsettings($name: String) {
            setup_systemsettings(name: $name) {
              data
            }
          }
        `,
        variables: { name: "msal" }
      });
      let data = query.data.setup_systemsettings[0].data
      data = Buffer.from(data, "base64").toString("ascii")
      let settings = JSON.parse(data)
      let key = process.env.VUE_APP_GRAPHQL_HTTP ? process.env.VUE_APP_GRAPHQL_HTTP : "http://localhost:8080"
      let setting = settings.find(o => o.key == key)

      if (setting) {
        localStorage.setItem(store.state.tokenid, "")

        let msalInstance = new PublicClientApplication(
          setting.msalConfig,
        );

        // MSAL.js v2 exposes several account APIs, logic to determine which account to use is the responsibility of the developer
        const account = msalInstance.getAllAccounts()[0];

        const accessTokenRequest = {
          scopes: ["user.read"],
          account: account,
        };

        let response = null
        try {
          response = await msalInstance.acquireTokenSilent(accessTokenRequest)
        } catch (error) {
          response = await msalInstance.acquireTokenPopup(accessTokenRequest)
        }
        if (response) {

          let variables = {
            access: key,
            accessToken: response.accessToken
          }
          commit('set', ['busy', true])
          try {
            let result = await apolloClient.mutate({
              mutation: gql`
                mutation($access:String, $accessToken: String!) {
                    signinToken(access:$access, accessToken: $accessToken ) {
                        token
                    }
                }
            `,
              variables
            })
            localStorage.setItem(store.state.tokenid, result.data.signinToken.token)
            router.go();
          } catch (error) {
            commit('set', ['error', error])
          }
          commit('set', ['busy', false])
        }
      }
    },
    signoutMS: async ({ commit }, payload) => {

      let query = await apolloClient.query({
        query: gql`
          query setup_systemsettings($name: String) {
            setup_systemsettings(name: $name) {
              data
            }
          }
        `,
        variables: { name: "msal" }
      });

      let data = query.data.setup_systemsettings[0].data
      data = Buffer.from(data, "base64").toString("ascii")
      let settings = JSON.parse(data)
      let key = process.env.VUE_APP_GRAPHQL_HTTP ? process.env.VUE_APP_GRAPHQL_HTTP : "http://localhost:8080"
      let setting = settings.find(o => o.key == key)
      if (setting) {
        let msalInstance = new PublicClientApplication(
          setting.msalConfig,
        );
        await msalInstance.logoutPopup({})
      }

    },
    signinUser: async ({ commit }, payload) => {
      commit('set', ['busy', true])
      try {
        let result = await apolloClient.mutate({
          mutation: gql`
              mutation($email: String!, $password: String!, $track: String) {
                  signinUser(email: $email, password: $password, track: $track ) {
                      token
                  }
              }
          `,
          variables: payload
        })
        localStorage.setItem(store.state.tokenid, result.data.signinUser.token)
        router.go();
      } catch (error) {
        commit('set', ['error', error])
      }
      commit('set', ['busy', false])
    },
    signoutUser: ({ commit, dispatch }) => {
      commit("setUser", null)
      localStorage.setItem(store.state.tokenid, "")
      router.push('/signin')
    },

    heartstart: async ({ commit, dispatch }) => {
      if (!store.state.heart) {
        console.log('no heart', store.state.heart)
        store.state.heart = setInterval(() => {
          dispatch("heartbeat")
        }, store.state.user.beats)
        console.log('heart id:', store.state.heart)
      }
      dispatch("heartbeat")
    },
    heartstop: async ({ commit, dispatch }) => {
      if (store.state.heart) {
        clearTimeout(store.state.heart);
        console.log('heart id: ', store.state.heart)
        store.state.heart = null;
      }
    },
    heartbeat: async ({ commit, dispatch }) => {
      //commit("setBeating", true);

      let jwtPayload = parseJwt(localStorage.getItem(store.state.tokenid))
      if (jwtPayload.exp < Date.now() / 1000) {
        commit("setUser", null)
        localStorage.setItem(store.state.tokenid, "")
        router.push('/signin')
      }

      if (store.state.user) {

        dispatch("notifications")
      }

      store.state.beating = !store.state.beating

      //commit("setBeating", false);
    },
    heartswitch: async ({ commit, dispatch }) => {
      if (store.state.heart) {
        dispatch('heartstop')
      } else {
        dispatch('heartstart')
      }
    },
    resize: async ({ commit }, payload) => {
      commit('set', ['window', payload])
    }
  },
  getters: {
    balance: state => state.balance,
    notifications: state => state.notifications,
    palette: state => state.palette,
    user: state => state.user,
    heart: state => state.heart,
    heartbeat: state => state.heartbeat,
    beating: state => state.beating,
    busy: state => state.busy,
    error: state => state.error,
    window: state => state.window,
  }
});
